module.exports = __webpack_public_path__ + "img/compliance3.6631088b.svg";